import { useDispatch } from "react-redux";

import { CaseDocumentAdmin } from "pwapi";

import { deleteAdminCaseDocument } from "shared/actions/admin/adminDocumentsActions";

import { PathologyWatchButton } from "components/customInputs/buttons/Button";

import WarningDialog from "../WarningDialog";

export const DocumentWarningDialog = ({
  document,
  onClose,
  closePanel,
}: {
  document: CaseDocumentAdmin;
  onClose: Function;
  closePanel: Function;
}) => {
  const dispatch = useDispatch();

  const onCompleteDeletion = () => {
    onClose();
    closePanel();
  };

  const onDeleteDocument = () => {
    document.id &&
      dispatch(
        deleteAdminCaseDocument({
          id: document.id,
          onClose: onCompleteDeletion,
        })
      );
  };

  return (
    <WarningDialog
      onClose={() => onClose()}
      title={document?.name && `Delete ${document.name}`}
    >
      <div className="CaseWarningDialog">
        <span>
          Are you sure you want to delete {document.name}?
          <br />
          This action cannot be undone.
        </span>
        <div className="actions__container">
          <PathologyWatchButton onClick={() => onClose()}>
            Cancel
          </PathologyWatchButton>
          <PathologyWatchButton
            type="submit"
            color="red"
            onClick={() => {
              onDeleteDocument();
            }}
          >
            Delete
          </PathologyWatchButton>
        </div>
      </div>
    </WarningDialog>
  );
};

export default DocumentWarningDialog;
